module.exports = __webpack_public_path__ + "static/media/deleteFilled.eb7b8749.svg";